import React, { ReactElement, useContext, useMemo, useReducer } from "react";
import { CartReducer, CartState } from "@cart-client/reducers/CartReducer";
import { GiftingCartReducer, GiftingCartState } from "@cart-client/reducers/GiftingCartReducer";
import { CartContext } from "@cart-client/contexts/CartContext";
import { CartFlowContext } from "@cart-client/contexts/CartFlowContext";
import { randomStringIdGenerator } from "@swiggy-private/core-ui";
import { INTERNAL_CART_SOURCE } from "@cart-client/interfaces/Cart";

const initialState: CartState | GiftingCartState = {
    localCart: null,
    reviewedCart: null,
    uniqueIdForCart: randomStringIdGenerator(),
};

export function CartContextProvider(props: { children: React.ReactNode }): ReactElement {
    const { data } = useContext(CartFlowContext);

    const reducer = useMemo(() => {
        switch (data?.cartSource) {
            case INTERNAL_CART_SOURCE.GIFTING:
                return GiftingCartReducer;
            default:
                return CartReducer;
        }
    }, [data?.cartSource]);

    const [cartState, setCartState] = useReducer(reducer, initialState);

    const cartContextValue = React.useMemo(
        () => ({
            cartState,
            setCartState,
        }),
        [cartState, setCartState],
    );
    return <CartContext.Provider value={cartContextValue}>{props.children}</CartContext.Provider>;
}
